<template>
    <div>
        <div class="content-box mr60">
            <el-form ref="form" label-width="120px" :model="formItem" :rules="rules" class="form-wrap">
                <el-form-item :style="{marginBottom: '4px'}">
                    <span :style="{fontSize: '12px'}">结单代表终止工单全部制作任务，未验收的素材会全部验收，提交后无法继续上传素材及修改。</span>
                </el-form-item>
                <el-form-item label="结单：" prop="app_type">
                    <el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" placeholder="请输入结单的理由，50字之内" v-model.trim="formItem.name" clearable maxlength="50" show-word-limit></el-input>
                </el-form-item>
            </el-form>
        </div>
        <p class="dialog-footer tac mt20">
            <el-button type="default" @click="hideModal" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="submitModal" :loading="formLoading" class="action-btn ml20">提交</el-button>
        </p>
    </div>
</template>
<!-- 工单管理  结算-->
<script>

import API from '@/api/workOrder/conf.js';
export default {
    name: "settleModal",
    data(){
        return {
            formLoading: false,
            formItem: {
                group: '',
            },
            rules: {},
        }
    },
    mounted() {
    },
    methods: {
        submitModal() {
            console.log('submitModal');
        },
        hideModal() {
            this.$emit('close');
        },
    }
}
</script>

<style scoped>

</style>
